module.exports = __webpack_public_path__ + "static/media/error-403.0cc2bb2e.png";